/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Link } from 'react-router';

import type { PatchedLocationDescriptor } from 'js/lib/connectToRouter';

import { ArrowPreviousIcon } from '@coursera/cds-icons';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';

import _t from 'i18n!nls/grading';

const styles = {
  link: () => css`
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-right: var(--cds-spacing-300);

    &:hover {
      background-color: var(--cds-color-blue-50);
    }

    &:focus {
      outline: none;
      text-decoration: none;
      background-color: var(--cds-color-blue-50);
      border: 1px solid var(--cds-color-purple-700);
      box-sizing: border-box;
      border-radius: 4px;
    }
  `,
  disabled: () => css`
    pointer-events: none;
    color: var(--cds-color-grey-600);
  `,
};

type Props = {
  routeOnClose: PatchedLocationDescriptor;
  tooltipMessage?: string;
  disabled?: boolean;
};

// Generic exit button for grading app
const ExitButton: React.FC<Props> = ({ routeOnClose, tooltipMessage, disabled }) => {
  return (
    <TooltipWrapper
      placement="bottom"
      tooltipId="BackToAssignmentGrading"
      delayShow={100}
      message={tooltipMessage || _t('Back')}
    >
      <Link to={routeOnClose} css={[styles.link, disabled && styles.disabled]} aria-label="Back">
        <ArrowPreviousIcon />
      </Link>
    </TooltipWrapper>
  );
};

export default ExitButton;
